import {
  AUTH_BROADCAST_TYPE,
  subscribeAuthBroadcast,
} from 'features/auth/helpers/crossTab';
import { clearAuthToken, saveRedirectUrl } from 'features/auth/helpers/helpers';
import { baseApi } from 'lib/rtkQuery/baseApi';
import { useAppDispatch } from 'lib/stores/hook';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPath } from 'routes/router-paths';

/** If any tab broadcast LOGOUT, clear session and redirect the user to login page immediately. */
export const useCrossTabAuthSync = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    return subscribeAuthBroadcast(message => {
      if (message.type !== AUTH_BROADCAST_TYPE.LOGOUT) return;

      saveRedirectUrl();
      clearAuthToken();
      dispatch(baseApi.util.resetApiState());
      navigate(getPath('loginPage'), { replace: true });
    });
  }, [dispatch, navigate]);
};
